import clsx from "clsx";
import styles from "./sample-subheader.module.scss";
import SampleSubheaderDivider from "./SampleSubheaderDivider";
import SampleSubheaderGroup from "./SampleSubheaderGroup";
import { SubheaderComponent } from "./types";

const SampleSubheader: SubheaderComponent = ({
  children,
  style,
  className
}) => (
  <header style={style} className={clsx(styles.subheader, className)}>
    {children}
  </header>
);

SampleSubheader.Group = SampleSubheaderGroup;
SampleSubheader.Divider = SampleSubheaderDivider;

export default SampleSubheader;
